import { App } from "antd";
import { ArgsProps, NotificationInstance } from "antd/es/notification/interface";

let appNotification: NotificationInstance
const notificationStyle = {
    // border: "1px solid #2ae471",
    minHeight: "60px",
    minWidth: "403px",
    fontWeight: "600",
    padding: "16px 12px 12px 21px",
    borderRadius: "8px",
    fontSize: "16px"
  }

export default function appNotificationInit(){
    const {notification} = App.useApp();

    appNotification = {
        open: (args: ArgsProps) => {
            return notification.open({ 
                message: args.message,
                description: args.description,
                placement: "topRight",
                duration: 10,
                // style: {...notificationStyle, 
                //     border: "1px solid #2c1250"},
                // className: 'bg-white c-default'
            });
        },
        success: (args: ArgsProps)=> {
            return notification.success({ 
                message: args.message,
                description: args.description,
                // style: {...notificationStyle,
                //     border: "1px solid #2ae471"},
                // className: 'bg-white c-default'
            });     
        },
        error: (args: ArgsProps) => {
            return notification.error( { 
                message: args.message,
                description: args.description,
                // style: {...notificationStyle,
                //     border: "1px solid #ff0000",
                //     backgroundColor: "#FCE9E9"},
                // className: 'bg-white c-default'
            } );
        },
        info: (args: ArgsProps) => {
            return notification.info( { 
                message: args.message,
                description: args.description,
                style: notificationStyle
            } );
        },
        warning: (args: ArgsProps) => {
            return notification.warning( { 
                message: args.message,
                description: args.description,
                // style: {...notificationStyle,
                //     border: "1px solid #ffdd8d"},
                // className: 'bg-white c-default'
            } );
        },
        destroy: () => {
            return notification.destroy();
        }
    };
    return null;
}
export { appNotification };
